@if (profile?.ForcePasswordChange) {
    <div id="forcePassChange" class="col-md-12">
        <div class="alert alert-warning">You have been forced to change your password by an administrator.</div>
    </div>
}

@if (error) {
    <div id="forcePassChange" class="col-md-12">
        <div class="alert alert-danger">
            {{ error }}
        </div>
    </div>
}

@if (success) {
    <div class="col-md-12">
        <div class="alert alert-success">Your password was changed successfully</div>
    </div>
}

<div class="col-md-12" style="margin-bottom: 15px">
    Passwords must be at least 6 characters long and have atleast 1 symbol, digit, uppercase, and lowercase character.
</div>

<form #frm="ngForm" (ngSubmit)="handleSubmit(frm)" id="main" class="form-horizontal">
    <div class="form-group">
        <label for="CurrentPassword" class="col-md-2 control-label">
            Current Password <span style="color: red">*</span>
        </label>
        <div class="col-md-4">
            <input
                autocomplete="password"
                class="form-control"
                ngModel
                required
                name="CurrentPassword"
                type="password"
                id="curPassword" />
        </div>
    </div>
    <div class="form-group">
        <label for="NewPassword" class="col-md-2 control-label"> New Password <span style="color: red">*</span> </label>
        <div class="col-md-4">
            <input
                autocomplete="new-password"
                class="form-control"
                ngModel
                required
                name="NewPassword"
                type="password"
                id="newPassword" />
        </div>
    </div>
    <div class="form-group">
        <label for="NewPasswordAgain" class="col-md-2 control-label">
            New Password Again <span style="color: red">*</span>
        </label>
        <div class="col-md-4">
            <input
                autocomplete="new-password"
                class="form-control"
                ngModel
                required
                name="NewPasswordAgain"
                type="password"
                id="newPasswordAgain" />
        </div>
    </div>
    <div class="form-group">
        <div class="col-md-offset-2 col-md-4">
            <div>
                <button id="SavePassword" [disabled]="frm.invalid" type="submit" class="btn btn-default">
                    Change Password
                </button>
            </div>
        </div>
    </div>
    <div class="col-md-offset-2 col-md-10">
        <span style="color: darkred" id="txtError"></span>
    </div>
</form>
